export default __webpack_public_path__ + "static/media/img3.49dc8338.jpg";